export const pdfOverlayConfigPersonal = {
  eng: {
    'Full Name': {
      page: 1,
      x: 270,
      y: 833,
      fontSize: 25,
      color: '#000000',
      fontWeight: 500
    },
    'Gender': {
      page: 1,
      x: 270,
      y: 868,
      fontSize: 25,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Date of Birth': {
      page: 1,
      x: 270,
      y: 903,
      fontSize: 25,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Collection Date': {
      page: 1,
      x: 270,
      y: 938,
      fontSize: 25,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Report Date': {
      page: 1,
      x: 270,
      y: 972,
      fontSize: 25,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Collection Kit Number': {
      page: 1,
      x: 270,
      y: 1007,
      fontSize: 25,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Report Number': {
      page: 1,
      x: 270,
      y: 1042,
      fontSize: 25,
      color: '#000000',
      fontWeight: 'normal'
    }
  },

  thai: {
    'Full Name': {
      page: 1,
      x: 270,
      y: 834,
      fontSize: 25,
      color: '#000000',
      fontWeight: 500
    },
    'Gender': {
      page: 1,
      x: 270,
      y: 865,
      fontSize: 25,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Date of Birth': {
      page: 1,
      x: 270,
      y: 901,
      fontSize: 25,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Collection Date': {
      page: 1,
      x: 270,
      y: 935,
      fontSize: 25,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Report Date': {
      page: 1,
      x: 270,
      y: 970,
      fontSize: 25,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Collection Kit Number': {
      page: 1,
      x: 270,
      y: 1006,
      fontSize: 25,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Report Number': {
      page: 1,
      x: 270,
      y: 1042,
      fontSize: 25,
      color: '#000000',
      fontWeight: 'normal'
    }
  }
};

// 9P Format
export const pdfOverlayConfigPersonal_9P = {
  eng: {
    'Full Name': {
        page: 1,
        x: 270,
        y: 838,
        fontSize: 22,
        color: '#000000',
        fontWeight: 500
    },
    'Gender': {
      page: 1,
      x: 270,
      y: 873,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
      'Date of Birth': {
      page: 1,
      x: 270,
      y: 908,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
      'Collection Date': {
      page: 1,
      x: 270,
      y: 942,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
      'Report Date': {
      page: 1,
      x: 270,
      y: 977,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
      'Order Number': {
      page: 1,
      x: 270,
      y: 1011,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
      'Report Number': {
      page: 1,
      x: 270,
      y: 1046,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    }
  },
  thai: {
    'Full Name': {
      page: 1,
      x: 270,
      y: 838,
      fontSize: 22,
      color: '#000000',
      fontWeight: 500
  },
  'Gender': {
    page: 1,
    x: 270,
    y: 872,
    fontSize: 22,
    color: '#000000',
    fontWeight: 'normal'
  },
    'Date of Birth': {
    page: 1,
    x: 270,
    y: 905,
    fontSize: 22,
    color: '#000000',
    fontWeight: 'normal'
  },
    'Collection Date': {
    page: 1,
    x: 270,
    y: 938,
    fontSize: 22,
    color: '#000000',
    fontWeight: 'normal'
  },
    'Report Date': {
    page: 1,
    x: 270,
    y: 973,
    fontSize: 22,
    color: '#000000',
    fontWeight: 'normal'
  },
    'Order Number': {
    page: 1,
    x: 270,
    y: 1011,
    fontSize: 22,
    color: '#000000',
    fontWeight: 'normal'
  },
    'Report Number': {
    page: 1,
    x: 270,
    y: 1045,
    fontSize: 22,
    color: '#000000',
    fontWeight: 'normal'
  }
  }
};

// Allergy Format
export const pdfOverlayConfigPersonal_allergy = {
  eng: {
    'Full Name': {
      page: 1,
      x: 270,
      y: 842,
      fontSize: 22,
      color: '#000000',
      fontWeight: 500
      },

    'Gender': {
      page: 1,
      x: 270,
      y: 876,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
      },

    'Date of Birth': {
      page: 1,
      x: 270,
      y: 911,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
    
    'Collection Date': {
      page: 1,
      x: 270,
      y: 946,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Report Date': {
      page: 1,
      x: 270,
      y: 980,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Collection Kit Number': {
      page: 1,
      x: 270,
      y: 1015,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Report Number': {
      page: 1,
      x: 270,
      y: 1049,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
  },

  thai: {
    'Full Name': {
      page: 1,
      x: 270,
      y: 838,
      fontSize: 25,
      color: '#000000',
      fontWeight: 500
    },
    'Gender': {
      page: 1,
      x: 270,
      y: 869,
      fontSize: 25,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Date of Birth': {
      page: 1,
      x: 270,
      y: 903,
      fontSize: 25,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Collection Date': {
      page: 1,
      x: 270,
      y: 938,
      fontSize: 25,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Report Date': {
      page: 1,
      x: 270,
      y: 974,
      fontSize: 25,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Order Number': {
      page: 1,
      x: 270,
      y: 1012,
      fontSize: 25,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Report Number': {
      page: 1,
      x: 270,
      y: 1046,
      fontSize: 25,
      color: '#000000',
      fontWeight: 'normal'
    },
  }
};

// Allergy Format
export const pdfOverlayConfigPersonal_allergy_kids = {
  eng: {
    'Full Name': {
      page: 1,
      x: 270,
      y: 840,
      fontSize: 22,
      color: '#000000',
      fontWeight: 500
      },

    'Gender': {
      page: 1,
      x: 270,
      y: 876,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
      },

    'Date of Birth': {
      page: 1,
      x: 270,
      y: 911,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
    
    'Collection Date': {
      page: 1,
      x: 270,
      y: 946,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Report Date': {
      page: 1,
      x: 270,
      y: 979,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Collection Kit Number': {
      page: 1,
      x: 270,
      y: 1013,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Report Number': {
      page: 1,
      x: 270,
      y: 1047,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
  },

  thai: {
    'Full Name': {
      page: 1,
      x: 270,
      y: 837,
      fontSize: 25,
      color: '#000000',
      fontWeight: 500
    },
    'Gender': {
      page: 1,
      x: 270,
      y: 869,
      fontSize: 25,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Date of Birth': {
      page: 1,
      x: 270,
      y: 903,
      fontSize: 25,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Collection Date': {
      page: 1,
      x: 270,
      y: 938,
      fontSize: 25,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Report Date': {
      page: 1,
      x: 270,
      y: 974,
      fontSize: 25,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Order Number': {
      page: 1,
      x: 270,
      y: 1010,
      fontSize: 25,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Report Number': {
      page: 1,
      x: 270,
      y: 1045,
      fontSize: 25,
      color: '#000000',
      fontWeight: 'normal'
    },
  }
};

  // toxin Format
export const pdfOverlayConfigPersonal_toxin = {
  eng: {
    'Full Name': {
      page: 1,
      x: 270,
      y: 834,
      fontSize: 22,
      color: '#000000',
      fontWeight: 500
      },

    'Gender': {
      page: 1,
      x: 270,
      y: 869,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
      },

    'Date of Birth': {
      page: 1,
      x: 270,
      y: 903,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
    
    'Collection Date': {
      page: 1,
      x: 270,
      y: 938,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Report Date': {
      page: 1,
      x: 270,
      y: 972,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Collection Kit Number': {
      page: 1,
      x: 270,
      y: 1007,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Report Number': {
      page: 1,
      x: 270,
      y: 1041,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
  },
  thai: {
    'Full Name': {
      page: 1,
      x: 270,
      y: 833,
      fontSize: 22,
      color: '#000000',
      fontWeight: 500
      },

    'Gender': {
      page: 1,
      x: 270,
      y: 865,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
      },

    'Date of Birth': {
      page: 1,
      x: 270,
      y: 899.5,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
    
    'Collection Date': {
      page: 1,
      x: 270,
      y: 936,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Report Date': {
      page: 1,
      x: 270,
      y: 969,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Collection Kit Number': {
      page: 1,
      x: 270,
      y: 1007,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Report Number': {
      page: 1,
      x: 270,
      y: 1041,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
  }
};


  // oms Format
export const pdfOverlayConfigPersonal_oms = {
  eng: {
    'Full Name': {
      page: 1,
      x: 270,
      y:839,
      fontSize: 22,
      color: '#000000',
      fontWeight: 500
      },

    'Gender': {
      page: 1,
      x: 270,
      y: 875,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
      },

    'Date of Birth': {
      page: 1,
      x: 270,
      y: 909,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
    
    'Collection Date': {
      page: 1,
      x: 270,
      y: 944,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Report Date': {
      page: 1,
      x: 270,
      y: 978,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Collection Kit Number': {
      page: 1,
      x: 270,
      y: 1013,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Report Number': {
      page: 1,
      x: 270,
      y: 1046,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
  },
  thai: {
    'Full Name': {
      page: 1,
      x: 270,
      y: 840,
      fontSize: 22,
      color: '#000000',
      fontWeight: 500
      },

    'Gender': {
      page: 1,
      x: 270,
      y: 873,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
      },

    'Date of Birth': {
      page: 1,
      x: 270,
      y: 906.5,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
    
    'Collection Date': {
      page: 1,
      x: 270,
      y: 945,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Report Date': {
      page: 1,
      x: 270,
      y: 976,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Collection Kit Number': {
      page: 1,
      x: 270,
      y: 1013,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
    'Report Number': {
      page: 1,
      x: 270,
      y: 1048,
      fontSize: 22,
      color: '#000000',
      fontWeight: 'normal'
    },
  }
};

// HN on the cover (all three BWC panels, eng + thai):
//   - hidden when empty (PdfStaticModal.js cover loop), so the ~1,800 reports
//     that predate the field do not grow a stray "N/A";
//   - bare value, no label, like the other cover lines (their labels are
//     printed on the artwork);
//   - y values are placeholders (Report Number + 35). Adjust by hand.
export const pdfOverlayConfigPersonal_bwcallergy = {
  eng: {
      'Full Name': {
          page: 1,
          x: 266,
          y: 644,
          fontSize: 27,
          color: '#3c3c3e',
          fontWeight: 'bold'
    },
      'HN': {
          page: 1,
          x: 266,
          y: 679,   // placeholder — reposition freely
          fontSize: 27,
          color: '#3c3c3e',
          fontWeight: 'bold'
      },
      'Gender': {
          page: 1,
          x: 266,
          y: 712,
          fontSize: 27,
          color: '#3c3c3e',
          fontWeight: 'bold'
    },
      'Date of Birth': {
          page: 1,
          x: 266,
          y: 748,
          fontSize: 27,
          color: '#3c3c3e',
          fontWeight: 'bold'
    },
    'Collection Date': {
          page: 1,
          x: 266,
          y: 781,
          fontSize: 27,
          color: '#3c3c3e',
          fontWeight: 'bold'
    },    
      'Report Date': {
          page: 1,
          x: 266,
          y: 816,
          fontSize: 27,
          color: '#3c3c3e',
          fontWeight: 'bold'
    },
      // This is the artwork's "Collection Kit Number" line on the BWC cover. The value
      // is the first 8 characters of the Report Number (20260001T1 -> 20260001).
      'Order Number': {
          page: 1,
          x: 266,
          y: 850,
          fontSize: 27,
          color: '#3c3c3e',
          fontWeight: 'bold'
    },
      'Report Number': {
          page: 1,
          x: 266,
          y: 885,
          fontSize: 27,
          color: '#3c3c3e',
          fontWeight: 'bold'
    },
  },

  thai: 
  {
    'Full Name': {
      page: 1,
      x: 317,
      y: 642,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
  'HN': {
      page: 1,
      x: 317,
      y: 677,   // placeholder — reposition freely
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
  },
  'Gender': {
      page: 1,
      x: 317,
      y: 710,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
  'Date of Birth': {
      page: 1,
      x: 317,
      y: 744,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
'Collection Date': {
      page: 1,
      x: 317,
      y: 778,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},    
  'Report Date': {
      page: 1,
      x: 317,
      y: 813,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
  // This is the artwork's "Collection Kit Number" line on the BWC cover. The value
  // is the first 8 characters of the Report Number (20260001T1 -> 20260001).
  'Order Number': {
      page: 1,
      x: 317,
      y: 850,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
  'Report Number': {
      page: 1,
      x: 317,
      y: 880,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
  }
};

export const pdfOverlayConfigPersonal_bwccore = {
  eng: {
    'Full Name': {
      page: 1,
      x: 266,
      y: 644,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
  'HN': {
      page: 1,
      x: 266,
      y: 679,   // placeholder — reposition freely
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
  },
  'Gender': {
      page: 1,
      x: 266,
      y: 713,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
  'Date of Birth': {
      page: 1,
      x: 266,
      y: 748,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
'Collection Date': {
      page: 1,
      x: 266,
      y: 783,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},    
  'Report Date': {
      page: 1,
      x: 266,
      y: 817,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
  // This is the artwork's "Collection Kit Number" line on the BWC cover. The value
  // is the first 8 characters of the Report Number (20260001T1 -> 20260001).
  'Order Number': {
      page: 1,
      x: 266,
      y: 852,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
  'Report Number': {
      page: 1,
      x: 266,
      y: 887,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
  },
  thai: {
    'Full Name': {
      page: 1,
      x: 317,
      y: 640,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
  'HN': {
      page: 1,
      x: 317,
      y: 675,   // placeholder — reposition freely
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
  },
  'Gender': {
      page: 1,
      x: 317,
      y: 710,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
  'Date of Birth': {
      page: 1,
      x: 317,
      y: 744,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
'Collection Date': {
      page: 1,
      x: 317,
      y: 778,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},    
  'Report Date': {
      page: 1,
      x: 317,
      y: 813,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
  // This is the artwork's "Collection Kit Number" line on the BWC cover. The value
  // is the first 8 characters of the Report Number (20260001T1 -> 20260001).
  'Order Number': {
      page: 1,
      x: 317,
      y: 848,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
  'Report Number': {
      page: 1,
      x: 317,
      y: 883,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
  }
};

export const pdfOverlayConfigPersonal_bwcdiamond = {
  eng: {
    'Full Name': {
      page: 1,
      x: 266,
      y: 644,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
  'HN': {
      page: 1,
      x: 266,
      y: 679,   // placeholder — reposition freely
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
  },
  'Gender': {
      page: 1,
      x: 266,
      y: 713,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
  'Date of Birth': {
      page: 1,
      x: 266,
      y: 748,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
'Collection Date': {
      page: 1,
      x: 266,
      y: 783,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},    
  'Report Date': {
      page: 1,
      x: 266,
      y: 816,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
  // This is the artwork's "Collection Kit Number" line on the BWC cover. The value
  // is the first 8 characters of the Report Number (20260001T1 -> 20260001).
  'Order Number': {
      page: 1,
      x: 266,
      y: 852,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
  'Report Number': {
      page: 1,
      x: 266,
      y: 887,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
  },
  thai: {
    'Full Name': {
      page: 1,
      x: 317,
      y: 640,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
  'HN': {
      page: 1,
      x: 317,
      y: 675,   // placeholder — reposition freely
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
  },
  'Gender': {
      page: 1,
      x: 317,
      y: 710,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
  'Date of Birth': {
      page: 1,
      x: 317,
      y: 744,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
'Collection Date': {
      page: 1,
      x: 317,
      y: 778,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},    
  'Report Date': {
      page: 1,
      x: 317,
      y: 813,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
  // This is the artwork's "Collection Kit Number" line on the BWC cover. The value
  // is the first 8 characters of the Report Number (20260001T1 -> 20260001).
  'Order Number': {
      page: 1,
      x: 317,
      y: 848,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
  'Report Number': {
      page: 1,
      x: 317,
      y: 883,
      fontSize: 27,
      color: '#3c3c3e',
      fontWeight: 'bold'
},
  }
};